import clsx from 'clsx';
import React from 'react';

import HighlightedText from '../../../../components/highlighted-text/HighlightedText';
import Icon from '../../../../icons/Icon';
import { ICONS } from '../../../../icons';

function AddProjectItem({ project, onClick, disabled, searchStr }) {
  const handleClick = () => {
    if (!onClick || disabled) {
      return;
    }

    onClick(project);
  };

  return (
    <div className={clsx('access_containers_container_item', disabled && 'access_containers_container_item--disabled')}>
      <div>
        <HighlightedText value={project.name} searchTerm={searchStr} />
      </div>
      <Icon icon={ICONS.CirclePlus} className={`access_containers_container_item_icon`} onClick={handleClick} />
    </div>
  );
}

export default AddProjectItem;
